import { styled } from '@mui/material/styles';
import MuiAppBar from '@mui/material/AppBar';

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ open }) => {
  const commonStyles = {
    backgroundColor: '#ECEDF4',
    boxShadow: 'none',
    width: '100%',
    marginLeft: '0%',
  };

  const closedStyles = {};

  const openStyles = {};

  return {
    zIndex: 1001,
    ...commonStyles,
    ...(open ? openStyles : closedStyles),
  };
});

export default AppBar;
